import { memo, useMemo } from 'react'
import { HStack, Tag } from '@chakra-ui/react'

import { useNotificationsManager } from 'contexts/NotificationsManager/Provider'

function NotificationsFilterAsTags() {
  const { filter, setFilter } = useNotificationsManager()

  function setFilterOnClickTag(value: string) {
    setFilter({ ...filter, viewed_at: value === '' ? value : JSON.parse(value) })
  }

  const filterOptions = useMemo(() => {
    return [
      { value: '', label: 'Todas' },
      { value: JSON.stringify({ $eq: null }), label: 'Não lidas' },
      { value: JSON.stringify({ $not: null }), label: 'Lidas' },
    ]
  }, [])

  return (
    <HStack>
      {filterOptions.map(({ label, value }) => {
        const viewedAt = filter.viewed_at == '' ? filter.viewed_at : JSON.stringify(filter.viewed_at)
        return (
          <Tag
            variant="solid"
            className="accessible"
            size="md"
            _hover={{ bg: 'lightPrimary' }}
            colorScheme={viewedAt === value ? 'primary' : 'gray'}
            key={label}
            onClick={() => setFilterOnClickTag(value)}
          >
            {label}
          </Tag>
        )
      })}
    </HStack>
  )
}

export default memo(NotificationsFilterAsTags)
